/**
 * Returns the scrollable Walkontable holder element for the current table container.
 */
export const getTableScrollableElement = (hotTableContainer: HTMLDivElement | null): Element | null =>
    hotTableContainer?.querySelector('.wtHolder') || null;

/**
 * Returns the parent container width used when tables stretch inside lists.
 */
export const getContainerWidth = (hotTableContainer: HTMLDivElement | null): number | undefined =>
    hotTableContainer?.parentElement?.getBoundingClientRect?.()?.width;

/**
 * Finds the root table DOM element for a Milanote table element id.
 */
export const getTableDomElementById = (id: string): HTMLDivElement | null =>
    document.querySelector<HTMLDivElement>(`.Table#el-${id}`);

/**
 * Returns the rendered width of the current HotTable element by Milanote element id.
 */
export const getHotTableWidthById = (id: string): number | undefined =>
    getTableDomElementById(id)?.querySelector('.HotTable')?.getBoundingClientRect?.()?.width;
